module.exports = __webpack_public_path__ + "img/profitability10.5f20d6c2.png";